import { observer } from "mobx-react";
import Icon from "../../../../../../../components/icons/icon/icon";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import IconCircle from "../../../../../../../components/icons/icon-circle/icon-circle";
import './on-off-indicator.scss';

interface IProps {
    is_on: boolean,
    on_label?: React.ReactChild,
    off_label?: React.ReactChild,
}

const OnOffIndicator: React.FC<IProps> = observer(({ is_on, on_label = 'ON', off_label = 'OFF' }) => {
    const IconComponent = () => <IconCircle color={is_on ? 'var(--color-semantic-success)' : 'var(--color-accent-3)'} />

    return (
        <div className="on-off-indicator">
            <Icon Component={IconComponent} />
            <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>
                {is_on ? on_label : off_label}
            </FontBody3>
        </div>
    );
});

export default OnOffIndicator;